import { format } from '@formkit/tempo'

export const prepareSearchData = (formData, cityId, langId) => ({
	check_in: format(formData.checkIn, 'YYYY-MM-DD'),
	check_out: format(formData.checkOut, 'YYYY-MM-DD'),
	adults: formData.adultsCount,
	childrens: formData.children.map(child => child.age),
	city_id: cityId,
	lang_id: langId,
})
